import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StaffInfo } from '../_models/authModel';
const USER_KEY = 'auth-user-pos';
const TOKEN_KEY = 'access-token-pos';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  jwtHelper = new JwtHelperService();
  constructor() {}

  clean(): void {
    localStorage.clear();
  }

  public saveToken(token: string): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.setItem(TOKEN_KEY, token);
  }

  public saveUser(user: StaffInfo): void {
    localStorage.removeItem(USER_KEY);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): StaffInfo {
    const user = localStorage.getItem(USER_KEY);
    if (user) {
      return JSON.parse(user);
    }

    return {
      id:'',
      roleCode: '',
      roleName: '',
      userCode: '',
      avatarUrl: '',
      email: '',
      fullName: '', 
      phone: '',
      branchCode: '',
      userLevel: ''
    };
  }

  loggedIn() {
    const token = localStorage.getItem(TOKEN_KEY);
    return !this.jwtHelper.isTokenExpired(token || '');
  }
}
